<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="12">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h3-semibold-black">La tua caldaia</h3>
            </b-col>

            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-Caldaia.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-form-group
              label="Quanti anni ha la tua caldaia?"
              label-for="field1"
              :state="states.anni"
          >
            <b-form-select id="field1" v-model="localOptions.caldaia.anni" :options="anniCaldaia"
                           @input="setValid($event,'anni')" class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Produce acqua calda per i sanitari?"
              label-for="field2"
              :state="states.acqua_calda"
          >
            <b-form-select id="field2" v-model="localOptions.caldaia.acqua_calda" :options="siNo"
                           @input="setValid($event,'acqua_calda')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-Caldaia.svg">
          </div>
          <button @click="nextStep" class="button-azure-rounded mt-2 lg:mt-8 px-8">Avanti</button>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>
export default {
  name: 'Step-3',
  data() {
    return {
      thisStep: 3,
      localOptions: null,
      siNo: [{text: 'Seleziona un valore', value: ''}, {text: 'Sì', value: true}, {text: 'No', value: false}],
      anniCaldaia: [{text: 'Anni Caldaia', value: ''},
        {
          text: 'Meno di 5',
          value: '-5'
        }, {
          text: 'Tra 5 e 10',
          value: '5-10'
        }, {
          text: 'Tra 10 e 15',
          value: '10-15'
        }, {
          text: 'Più di 15',
          value: '+15'
        }, {
          text: 'Non sò',
          value: 'non so'
        },

      ],
      loading: true,
      states: {},
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    if (this.options.step < this.thisStep) this.$router.push({name: 'step-1'})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;

    if(typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-3');
    }
  },
  methods: {
    nextStep() {
      let that = this;
      let valid = true;
      that.states = {};
      for (const [key, value] of Object.entries(that.localOptions.caldaia)) {
        if (value === null || value === '') {
          that.states[key] = true;
          valid = false;
        }
      }
      if (valid) this.$emit('nextStep', this.thisStep + 1, this.localOptions)
    },
    setValid(value, key) {
      this.states[key] = value === null || value === '';
    }
  },
}
</script>

<style scoped lang="scss">
</style>